/**
 * Typed binding for `GET /healthz`.
 *
 * The healthcheck is intentionally the smallest possible surface — every
 * future client (`quotes`, `proposals`, `users`, ...) follows this exact
 * shape: take a `Transport`, expose verb-named methods that return the
 * inferred response type.
 */

import { HealthResponseSchema, type HealthResponse } from '../schemas/health.js';
import type { RequestOptions, Transport } from './transport.js';

export interface HealthClient {
  check(options?: RequestOptions): Promise<HealthResponse>;
}

export const createHealthClient = (transport: Transport): HealthClient => ({
  check: (options) => transport.get('/healthz', HealthResponseSchema, options),
});
